export const styleBoxPlanInfo = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};
export const styleBoxPlanImage = {
  height: 200,
};
